/* ================================================================
   Gift Redeem Page — Behaviour
   Step 1: verify gift code
   Step 2: show API details, then Buy → checkout URL
================================================================= */

(function () {
  'use strict';

  var REDEEM_VERIFY_BASE = '/apps/data/gift-redeem-verify/';
  var REDEEM_SUBMIT_BASE = '/apps/data/gift-redeem-submit/';

  var PARAM_CODE = 'code';
  var PARAM_STEP = 'step';
  var currentStep = '1';
  var verifiedGift = null;

  var card = document.getElementById('giftStepperCard');
  var codeForm = document.getElementById('redeemCodeForm');
  var giftCodeInput = document.getElementById('giftCode');
  var codeError = document.getElementById('giftCodeError');
  var verifyBtn = document.getElementById('verifyCodeBtn');
  var changeCodeBtn = document.getElementById('changeCodeBtn');
  var checkoutBtn = document.getElementById('checkoutBtn');
  var checkoutError = document.getElementById('redeemCheckoutError');
  var experienceLine = document.getElementById('redeemExperienceLine');
  var noteCard = document.getElementById('redeemNoteCard');
  var noteLabelEl = document.getElementById('redeemNoteLabel');
  var noteValueEl = document.getElementById('redeemNoteValue');
  var stepPanels = card ? card.querySelectorAll('[data-step-panel]') : [];
  var stepTabs = card ? card.querySelectorAll('[data-goto-step]') : [];

  function apiHeaders(includeJson) {
    var headers = {
      Accept: 'application/json',

    };
    if (includeJson) {
      headers['Content-Type'] = 'application/json';
    }
    return headers;
  }

  function redeemUrl(base, code) {
  return base + encodeURIComponent(code);
}

  var lockedCardHeight = 0;

  function lockCardSize() {
    if (!card) {
      return;
    }

    var step1 = card.querySelector('[data-step-panel="1"]');
    var step2 = card.querySelector('[data-step-panel="2"]');

    if (step1 && !step1.hidden) {
      card.style.height = '';
      card.style.minHeight = '';
      var height = Math.round(card.getBoundingClientRect().height);
      if (height > 0) {
        lockedCardHeight = height;
        card.style.minHeight = height + 'px';
      }
      return;
    }

    if (step2 && !step2.hidden) {
      card.style.height = 'auto';
      card.style.minHeight = lockedCardHeight > 0 ? lockedCardHeight + 'px' : '';
    }
  }

  function readParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      code: (params.get(PARAM_CODE) || params.get('giftCode') || '').trim(),
      step: params.get(PARAM_STEP) === '2' ? '2' : '1'
    };
  }

  function syncUrl() {
    var params = new URLSearchParams(window.location.search);
    var code = giftCodeInput ? giftCodeInput.value.trim() : '';

    if (code) {
      params.set(PARAM_CODE, code);
    } else {
      params.delete(PARAM_CODE);
    }

    if (currentStep === '2' && verifiedGift) {
      params.set(PARAM_STEP, '2');
    } else {
      params.delete(PARAM_STEP);
    }

    var query = params.toString();
    var next = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next !== current) {
      window.history.replaceState(null, '', next);
    }
  }

  function setStep(step, options) {
    var n = String(step);
    options = options || {};

    currentStep = n;

    stepPanels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-step-panel') !== n;
    });
    stepTabs.forEach(function (tab) {
      var active = tab.getAttribute('data-goto-step') === n;
      tab.classList.toggle('is-active', active);
      if (active) {
        tab.setAttribute('aria-current', 'step');
      } else {
        tab.removeAttribute('aria-current');
      }
    });

    window.requestAnimationFrame(lockCardSize);

    if (!options.skipUrl) {
      syncUrl();
    }
  }

  function showCodeError(text) {
    if (!codeError) {
      return;
    }
    codeError.textContent = text || 'Please enter a valid gift code.';
    codeError.hidden = false;
    if (giftCodeInput) {
      giftCodeInput.classList.add('is-invalid');
    }
  }

  function clearCodeError() {
    if (!codeError) {
      return;
    }
    codeError.textContent = '';
    codeError.hidden = true;
    if (giftCodeInput) {
      giftCodeInput.classList.remove('is-invalid');
    }
  }

  function showCheckoutError(text) {
    if (!checkoutError) {
      return;
    }
    checkoutError.textContent = text;
    checkoutError.hidden = false;
  }

  function clearCheckoutError() {
    if (!checkoutError) {
      return;
    }
    checkoutError.textContent = '';
    checkoutError.hidden = true;
  }

  function setBusy(button, isBusy) {
    if (!button) {
      return;
    }
    button.disabled = isBusy;
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function unwrapPayload(data) {
    if (!data || typeof data !== 'object') {
      return {};
    }
    return data.data || data.gift || data.result || data;
  }

  function pick(obj, keys) {
    var i;
    for (i = 0; i < keys.length; i++) {
      if (obj[keys[i]] != null && String(obj[keys[i]]).trim() !== '') {
        return obj[keys[i]];
      }
    }
    return '';
  }

  function formatExpiry(iso) {
    if (!iso) {
      return '';
    }
    var date = new Date(iso);
    if (isNaN(date.getTime())) {
      return '';
    }
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function normalizeGift(raw, code) {
    var gift = unwrapPayload(raw);
    var plan = gift.plan || {};
    var durationLabel = pick(plan, ['durationLabel', 'title']) || pick(gift, ['durationLabel', 'title']);

    return {
      giftCode: pick(gift, ['discountCode', 'giftCode', 'code']) || code,
      recipientName: pick(gift, ['recipientName', 'recipient_name']),
      fromName: pick(gift, ['gifterName', 'fromName', 'from_name', 'senderName']),
      giftMessage: pick(gift, ['giftMessage', 'gift_message', 'message']),
      durationLabel: durationLabel || 'Gift membership',
      expiresAt: formatExpiry(gift.expiresAt || gift.expires_at),
      alreadyClaimed: gift.alreadyClaimed === true || gift.status === 'claimed' || gift.state === 'redeemed',
      checkoutUrl: extractCheckoutUrl(raw) || extractCheckoutUrl(gift)
    };
  }

  function extractCheckoutUrl(data) {
    if (!data) {
      return '';
    }
    if (typeof data === 'string' && /^https?:\/\//.test(data)) {
      return data;
    }
    var nested = unwrapPayload(data);
    return (
      data.checkoutUrl ||
      data.checkout_url ||
      data.url ||
      data.redirectUrl ||
      nested.checkoutUrl ||
      nested.checkout_url ||
      nested.url ||
      nested.redirectUrl ||
      ''
    );
  }

  function monthCount(label) {
    var match = String(label || '').match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function monthWords(count) {
    var words = {
      1: 'one',
      3: 'three',
      6: 'six',
      12: 'twelve'
    };
    return words[count] || String(count);
  }

  function renderGift(gift) {
    if (experienceLine) {
      var count = monthCount(gift.durationLabel);
      var html = 'Enjoy whisky discovery, with 11 whiskies, tasting snacks and live tastings along the way.';
      if (count === 1) {
        html = 'Enjoy <strong>one month</strong> of whisky discovery, with 11 whiskies, tasting snacks and live tastings along the way.';
      } else if (count > 1) {
        html = 'Enjoy <strong>' + monthWords(count) + ' months</strong> of whisky discovery, with 11 whiskies, tasting snacks and live tastings along the way.';
      }
      if (gift.expiresAt) {
        html += ' Redeem your gift by <strong>' + gift.expiresAt + '</strong>.';
      }
      experienceLine.innerHTML = html;
    }

    if (noteCard && noteValueEl) {
      if (gift.giftMessage) {
        if (noteLabelEl) {
          noteLabelEl.textContent = gift.fromName ? 'A note from ' + gift.fromName : 'A personal note';
        }
        noteValueEl.textContent = gift.giftMessage;
        noteCard.hidden = false;
      } else {
        noteValueEl.textContent = '';
        noteCard.hidden = true;
      }
    }
  }

  function parseErrorMessage(data, fallback) {
    if (!data || typeof data !== 'object') {
      return fallback;
    }
    var nested = data.data && typeof data.data === 'object' ? data.data : {};
    if (typeof data.message === 'string' && data.message.trim()) {
      return data.message.trim();
    }
    if (typeof nested.message === 'string' && nested.message.trim()) {
      return nested.message.trim();
    }
    if (typeof data.error === 'string' && data.error) {
      if (data.error === 'not_found') {
        return 'That gift code could not be found. Please check it and try again.';
      }
      if (data.error !== 'validation_error') {
        return data.error;
      }
    }
    if (Array.isArray(data.issues) && data.issues[0] && data.issues[0].message) {
      return data.issues[0].message;
    }
    return fallback;
  }

  function assertApiOk(response, data, fallback) {
    var failed =
      !response.ok ||
      data.success === false ||
      (typeof data.code === 'number' && data.code >= 400);
    if (failed) {
      throw new Error(parseErrorMessage(data, fallback));
    }
  }

  function verifyCode() {
    var code = giftCodeInput ? giftCodeInput.value.trim() : '';
    clearCodeError();

    if (!code) {
      showCodeError('Please enter your gift code.');
      if (giftCodeInput) {
        giftCodeInput.focus();
      }
      return;
    }

    setBusy(verifyBtn, true);
    syncUrl();

   fetch(redeemUrl(REDEEM_VERIFY_BASE, code), {
     method: 'GET',
      headers: apiHeaders(false)
    })
      .then(function (response) {
        return response.json().catch(function () {
          return {};
        }).then(function (data) {
          assertApiOk(response, data, 'That gift code could not be verified. Please check it and try again.');
          return data;
        });
      })
      .then(function (data) {
        var gift = normalizeGift(data, code);
        if (gift.alreadyClaimed) {
          throw new Error('This gift code has already been redeemed.');
        }
        if (data.state && data.state !== 'ready') {
          throw new Error('This gift code cannot be redeemed right now.');
        }
        verifiedGift = gift;
        renderGift(verifiedGift);
        setBusy(verifyBtn, false);
        setStep(2);
      })
      .catch(function (error) {
        console.error(error);
        verifiedGift = null;
        setBusy(verifyBtn, false);
        showCodeError(error.message || 'That gift code could not be verified. Please check it and try again.');
      });
  }

  function startCheckout() {
    clearCheckoutError();

    if (!verifiedGift || !verifiedGift.giftCode) {
      showCheckoutError('Please verify your gift code first.');
      setStep(1);
      return;
    }

    if (verifiedGift.checkoutUrl) {
      window.location.href = verifiedGift.checkoutUrl;
      return;
    }

    setBusy(checkoutBtn, true);

    fetch(redeemUrl(REDEEM_SUBMIT_BASE, verifiedGift.giftCode), {
      method: 'POST',
      headers: apiHeaders(true),
      body: JSON.stringify({})
    })
      .then(function (response) {
        return response.json().catch(function () {
          return {};
        }).then(function (data) {
          assertApiOk(response, data, 'We could not start checkout. Please try again.');
          return data;
        });
      })
      .then(function (data) {
        var checkoutUrl = extractCheckoutUrl(data);
        if (!checkoutUrl) {
          throw new Error('Checkout response did not include a URL');
        }
        window.location.href = checkoutUrl;
      })
      .catch(function (error) {
        console.error(error);
        showCheckoutError(error.message || 'We could not start checkout. Please try again.');
        setBusy(checkoutBtn, false);
      });
  }

  function initStepper() {
    if (codeForm) {
      codeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        verifyCode();
      });
    }

    if (changeCodeBtn) {
      changeCodeBtn.addEventListener('click', function () {
        verifiedGift = null;
        setStep(1);
        if (giftCodeInput) {
          giftCodeInput.focus({ preventScroll: true });
        }
      });
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', startCheckout);
    }

    stepTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var step = tab.getAttribute('data-goto-step');
        if (step === '2') {
          if (verifiedGift) {
            setStep(2);
            return;
          }
          verifyCode();
          return;
        }
        setStep(1);
      });
    });
  }

  function initGiftFaq() {
    var headings = document.querySelectorAll('#giftFaqSection .faq_headding_question');
    if (!headings.length) {
      return;
    }

    headings.forEach(function (heading) {
      heading.addEventListener('click', function () {
        var parent = heading.closest('.faq_accordian');
        var isOpen = parent && parent.classList.contains('active');
        document.querySelectorAll('#giftFaqSection .faq_accordian').forEach(function (item) {
          item.classList.remove('active');
        });
        if (parent && !isOpen) {
          parent.classList.add('active');
        }
      });
    });
  }

  function init() {
    if (!card) {
      return;
    }

    var saved = readParams();
    if (giftCodeInput && saved.code) {
      giftCodeInput.value = saved.code;
    }

    if (giftCodeInput) {
      giftCodeInput.addEventListener('input', syncUrl);
    }

    initStepper();
    initGiftFaq();
    window.requestAnimationFrame(lockCardSize);
    window.addEventListener('resize', lockCardSize);

    if (saved.code) {
      verifyCode();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
